import { pubSub } from '@utils/PubSub';

export default class InternationalToast {
  constructor() {
    this.element = {
      modal: document.querySelector('.Toast--International'),
      closeBtns: [...document.querySelectorAll('.Toast--International .close')],
    };
    pubSub.subscribe('dy:international-toast:init', () => {
      this.init();
    });
  }

  init() {
    const { modal, closeBtns } = this.element;
    if (modal) {
      modal.classList.add('Toast--Active');
      closeBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          modal?.classList?.remove('Toast--Active');
        });
      });
    }
  }
}
